module.exports = __webpack_public_path__ + "static/media/gold.12dfda19.png";